import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates'
import SubirImagenes from '../SubirImagenes';
import { FaPlus } from "react-icons/fa";

import axios from 'axios'
import { Url } from '../Url'


const FEditProducto = () => {
    const [codigo, setCodigo] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [descripcionExt, setDescripcionExt] = useState('')
    const [precio, setPrecio] = useState('')
    const [precioCosto, setPrecioCosto] = useState('')
    const [precioPromo, setPrecioPromo] = useState('')
    const [precioMayor, setPrecioMayor] = useState('')

    const [marcas, setMarcas] = useState([])
    const [marca, setMarca] = useState(0)

    const [rubros, setRubros] = useState([])
    const [rubro, setRubro] = useState(0)

    /*const [modelos, setModelos] = useState([])
    const [modelo, setModelo] = useState(0)*/

    const [talles, setTalles] = useState([])
    const [talle, setTalle] = useState(0)

    const [colores, setColores] = useState([])
    const [color, setColor] = useState(0)

    const [bgColor, setBgColor] = useState('')

    const [guardar, setGuardar] = useState(false)
    const [modStock, setModStock] = useState(false)

    const [stock, setStock] = useState(0)
    const [stockMin, setStockMin] = useState(0)

    const [stockAdd, setStockAdd] = useState(0)
    const [idProducto, setIdProducto] = useState(0)
    const { productoSelected, setProductoSelected, modify, valModelo, setModify, setFormView, setViewOpen, idUsuario, roles } = useContext(ContextStates)


    let tipoImagen = "productos";
    let idHtml = "imagenesProducto";
    const childRef = useRef()

    useEffect(() => {
        if (idProducto !== 0) {
            console.log("arranca la subida de imagen")
            childRef.current.handleSubmit();
        }
    }, [idProducto])

    useEffect(() => {
        setCodigo(productoSelected.codigo)
        setDescripcion(productoSelected.descripcion)
        setDescripcionExt(productoSelected.descripcionext)
        setPrecio(productoSelected.precio)
        setPrecioCosto(productoSelected.preciocosto)
        setPrecioPromo(productoSelected.preciopromocion)
        setPrecioMayor(productoSelected.preciopormayor)
        setMarca(productoSelected.idmarca)
        setRubro(productoSelected.idrubro)
        console.log("idrubro ", productoSelected.idrubro)
        //setModelo(productoSelected.idmodelo)
        setStock(productoSelected.stock)
        setStockMin(productoSelected.stockmin)
        setColor(productoSelected.idcolor)
        setTalle(productoSelected.idtalle)
    }, [])

    useEffect(() => {
        if (stock !== '' && stock !== 0 && stockAdd !== '' && stockAdd !== 0) {
            let aux = parseFloat(productoSelected.stock) + parseFloat(stockAdd);
            setStock(aux)

        }
    }, [stockAdd])

    useEffect(() => {
        const consultaMarcas = async () => {
            const url = Url + 'api/listadomarcas.php';
            const resultado = await axios.get(url);
            console.log(resultado);
            setMarcas(resultado.data.results);
        }
        consultaMarcas()
    }, [])

    useEffect(() => {
        const consultaRubros = async () => {
            const url = Url + 'api/listRubros.php';
            const resultado = await axios.get(url);
            setRubros(resultado.data.results);
            /*if (rubro === 0) {
                setRubro(resultado.data.results[0].id)
            }*/

        }
        consultaRubros()
    }, [])

    useEffect(() => {
        colores.forEach(element => {
            if (element.id === color) {
                setBgColor(element.codigo)
            }
        });
    }, [color])

    /*useEffect(() => {
        const consultaModelos = async () => {
            if (marca!==0 && rubro!==0) {
                const formData = new FormData()
                formData.append("marca", marca)
                formData.append("rubro", rubro)
                formData.append("modelo", '')
                try {
                    const response = await axios({
                        url: Url + 'api/listadomodelos.php',
                        method: 'POST',
                        data: formData,
                    })
                    setModelos(response.data.results)
                } catch (e) {
                    console.log(e)
                }    
            }
        }
        consultaModelos()
    }, [valModelo, marca, rubro])*/

    useEffect(() => {
        const consultaTalles = async () => {
            const formData = new FormData()

            try {
                const response = await axios({
                    url: Url + 'api/listadotalles.php',
                    method: 'POST',
                    data: formData,
                })
                setTalles(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaTalles()
    }, [])

    useEffect(() => {
        const consultaColores = async () => {
            const formData = new FormData()

            try {
                const response = await axios({
                    url: Url + 'api/listadocolores.php',
                    method: 'POST',
                    data: formData,
                })
                setColores(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaColores()
    }, [])

    const setProducto = async () => {
        if (guardar) {
            setGuardar(false)
            const formData = new FormData()
            formData.append('id', productoSelected.id);
            formData.append('codigo', codigo);
            formData.append('descripcion', descripcion);
            formData.append('descripcionext', descripcionExt);
            formData.append('idmarca', marca);
            formData.append('idrubro', rubro);
            formData.append('color', color);
            formData.append('precio', precio);
            formData.append('preciocosto', precioCosto);
            formData.append('preciopromo', precioPromo);
            formData.append('preciomayor', precioMayor);
            formData.append('idusuario', idUsuario);
            try {
                const results = await axios({
                    url: Url + 'api/setProductos.php',
                    method: 'POST',
                    data: formData,
                })
                setIdProducto(productoSelected.id)
                console.log(results)
                let aux = modify + 1;
                setModify(aux)
                setViewOpen(false)
            } catch (e) {
                console.log(e)
            }

        }
    }

    useEffect(() => {
        const checkForm = () => {
            let error = 0;
            if (descripcion === '')
                error = 1;
            if (precio === '')
                error = 1;
            if (codigo === '')
                error = 1;
            if (stock === '')
                error = 1;
            if (marca === 0)
                error = 1;
            if (rubro === 0)
                error = 1;
            /*if (modelo === 0)
                error = 1;*/

            if (error === 0)
                setGuardar(true)
            else
                setGuardar(false)
        }
        checkForm()
    }, [descripcion, codigo, precio, stock, rubro, /*modelo,*/ marca])

    const actualizarStock = async () => {
        const formData = new FormData()
        formData.append('id', productoSelected.id);
        formData.append('stock', stock);
        formData.append('stockmin', stockMin);
        formData.append('idusuario', idUsuario);
        try {
            const results = await axios({
                url: Url + 'api/setStock.php',
                method: 'POST',
                data: formData,
            })
            console.log(results)
            let aux = modify + 1;
            let productoAux = productoSelected;
            productoAux.stock = stock;
            setProductoSelected(productoAux)
            setModify(aux)
            setModStock(false)
        } catch (e) {
            console.log(e)
        }
    }

    const handleAdd = (form) => {
        setFormView(form)
        setViewOpen(true)
    }

    return (

        <div className="transition-all w-full pt-5 sm:p-3 mt-5">
            {roles.includes("10") && (
                <>
                    <h2 className='text-center text-gray-700 text-xl'>Edición de Productos</h2>
                    <div className="w-full mt-5 py-2 px-3 rounded-2xl" >
                        <div className='flex'>
                            <div className='w-1/2 mx-auto m-3 p-2'>
                                <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                                    <h4 className='text-center text-gray-700 uppercase'>Producto, rubro, marca y modelo</h4>
                                    <div className="sm:items-start">
                                        <label htmlFor="codigo" className="block mt-5 text-gray-600 uppercase">Código</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="codigo"
                                            placeholder="Código de producto"
                                            type="text"
                                            value={codigo}
                                            onChange={(e) => setCodigo(e.target.value)}
                                            autoFocus
                                        />
                                    </div>
                                    <div className="sm:items-start">
                                        <label htmlFor="descripcion" className="block mt-5 text-gray-600 uppercase">Descripción</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="descripcion"
                                            placeholder="Descripción"
                                            type="text"
                                            value={descripcion}
                                            onChange={(e) => setDescripcion(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start mt-5">
                                        <label htmlFor="descripcionExt" className="block text-gray-600 uppercase">Descripción detallada</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="descripcionExt"
                                            placeholder="Ingrese una descripción detallada"
                                            type="text"
                                            value={descripcionExt}
                                            onChange={(e) => setDescripcionExt(e.target.value)}
                                        />
                                    </div>
                                    <label htmlFor="sRubro" className="w-full block mt-5 text-gray-600 uppercase">Rubro</label>
                                    <select
                                        className='py-2 px-3 w-full rounded bg-slate-100'
                                        id='sRubro'
                                        onChange={(e) => setRubro(e.target.value)}
                                        value={rubro}
                                    >
                                        {rubros && (
                                            rubros.map(item => (
                                                <option key={item.id} value={item.id}>{item.descripcion}</option>))
                                        )}
                                    </select>

                                    <label htmlFor="sMarca" className="w-full block mt-5 text-gray-600 uppercase">Marca</label>
                                    <select
                                        className='py-2 px-3 w-full rounded bg-slate-100'
                                        id='sMarca'
                                        onChange={(e) => setMarca(e.target.value)}
                                        value={marca}
                                    >
                                        {marcas && (
                                            marcas.map(item => (
                                                <option key={item.id} value={item.id}>{item.descripcion}</option>))
                                        )}
                                    </select>
                                    <label htmlFor="sColor" className="w-full block mt-5 text-gray-600 uppercase">Color</label>
                                    <div className='flex'>
                                        <select
                                            className='py-2 px-3 w-full rounded bg-slate-100 mr-2'
                                            id='sColor'
                                            value={color}
                                            onChange={(e) => setColor(e.target.value)}
                                        >
                                            {colores && (
                                                colores.map(item => (
                                                    <option key={item.id} value={item.id}>{`${item.nombre}`}</option>))
                                            )}
                                        </select>
                                        <div className={`p-2 w-1/4 bg-${bgColor}`}></div>
                                    </div>
                                    <div className='w-full flex h-24'>
                                        {   (typeof(productoSelected.imagenes[0])!=='undefined' && productoSelected.imagenes.length>=0) && (
                                            <div className='w-1/3'>
                                                <img className='w-full object-cover rounded print:invisible' src={Url + productoSelected.imagenes[0].imagen} />
                                            </div>
                                        )}
                                        <SubirImagenes
                                            id={idProducto}
                                            tipo={tipoImagen}
                                            ref={childRef}
                                            idHtml={idHtml}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='w-1/2 mx-auto m-3 p-2'>
                                <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                                    <h4 className='text-center text-gray-700 uppercase'>Precio, unidad y Stock</h4>
                                    <div className="sm:items-start">

                                        <label htmlFor="precio" className="block mt-5 text-gray-600 uppercase">Precio de venta</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precio"
                                            placeholder="Precio de venta"
                                            type="text"
                                            value={precio}
                                            onChange={(e) => setPrecio(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start">

                                        <label htmlFor="precioCosto" className="block mt-5 text-gray-600 uppercase">Precio de costo</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precioCosto"
                                            placeholder="Precio de costo"
                                            type="text"
                                            value={precioCosto}
                                            onChange={(e) => setPrecioCosto(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start">
                                        <label htmlFor="precioPromo" className="block mt-5 text-gray-600 uppercase">Precio de Promoción</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precioPromo"
                                            placeholder="Precio de Promoción"
                                            type="text"
                                            value={precioPromo}
                                            onChange={(e) => setPrecioPromo(e.target.value)}
                                        />
                                    </div>
                                    <div className="sm:items-start">

                                        <label htmlFor="precioMayor" className="block mt-5 text-gray-600 uppercase">Precio por mayor</label>
                                        <input
                                            className="py-2 px-3 w-full border border-gray-300 rounded"
                                            id="precioMayor"
                                            placeholder="Precio por mayor"
                                            type="text"
                                            value={precioMayor}
                                            onChange={(e) => setPrecioMayor(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                                    <p className='text-lg font-bold'>Stock Actual: {productoSelected.stock}</p>
                                    {modStock ? (
                                        <div>
                                            <div className="sm:items-start mt-5">
                                                <label htmlFor="stock" className="block mt-5 text-gray-600 uppercase">Nuevo Stock</label>
                                                <input
                                                    className="py-2 px-3 w-full border border-gray-300 rounded"
                                                    id="stock"
                                                    placeholder="Nuevo Stock"
                                                    type="text"
                                                    value={stock}
                                                    onChange={(e) => setStock(e.target.value)}
                                                />
                                                <label htmlFor="stockAdd" className="block mt-5 text-gray-600 uppercase">Stock a agregar</label>
                                                <input
                                                    className="py-2 px-3 w-full border border-gray-300 rounded"
                                                    id="stockAdd"
                                                    placeholder="Ingrese la cantidad a agregar"
                                                    type="text"
                                                    value={stockAdd}
                                                    onChange={(e) => setStockAdd(e.target.value)}
                                                />
                                            </div>
                                            <div className="sm:items-start">

                                                <label htmlFor="stockMin" className="block mt-5 text-gray-600 uppercase">Stock mínimo</label>
                                                <input
                                                    className="py-2 px-3 w-full border border-gray-300 rounded"
                                                    id="stockMin"
                                                    placeholder="Stock mínimo"
                                                    type="text"
                                                    value={stockMin}
                                                    onChange={(e) => setStockMin(e.target.value)}
                                                />
                                            </div>
                                            <div className='w-full pt-5'>
                                                <button
                                                    type='button'
                                                    className='p-2 bg-red-500 text-white rounded'
                                                    onClick={() => actualizarStock()}
                                                >Modificar</button>
                                                <button
                                                    type='button'
                                                    className='p-2 bg-gray-500 text-white rounded ml-5'
                                                    onClick={() => setModStock(false)}
                                                >Cancelar</button>
                                            </div>
                                        </div>

                                    ) : (
                                        roles.includes("12") &&
                                        <div className='mt-5'>
                                            <button
                                                type='button'
                                                className='p-2 bg-blue-500 text-white rounded'
                                                onClick={() => setModStock(true)}
                                            >Modificar Stock</button>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div className="mt-auto">
                            <div className="w-full rounded-lg px-3">
                                <button
                                    type="submit"
                                    className={`"w-full shadow-md p-3 text-gray-100 hover:text-gray-300 transition-all uppercase font-bold rounded-lg mt-5" ${guardar ? 'bg-orange-600' : 'bg-orange-300'}`}
                                    onClick={() => setProducto()}
                                >
                                    Guardar Datos
                                </button>
                            </div>
                        </div>

                    </div>
                </>
            )}

        </div>
    )
}

export default FEditProducto